import {
  Button,
  Checkbox,
  Form,
  Link,
  TextField,
  TextStyle,
  DisplayText
} from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';
import React, { Component } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';

const LoginFormParent = styled.div`
  .footer-block {
    margin-top: 32px;
  }

  .Polaris-Choice {
    margin-top: 4px;
  }

  .Polaris-Choice__Label {
    font-weight: 500;
  }

  .Polaris-TextField {
    max-width: 424px;
  }
`;

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenantid: '',
      username: props.username || '',
      password: '',
      remeberme: 'on',
      trustme: this.props?.trustme || false,
      showPassword: false,
      idpFlow: this.props?.idpFlow || false
    };
  }

  login = () => {
    const {
      tenantid,
      username,
      password,
      remeberme,
      trustme,
      idpFlow
    } = this.state;
    this.props.LoginUser({ tenantid, username, password, remeberme, trustme });
  };

  handleChange = (field) => {
    return (value) => this.setState({ [field]: value });
  };

  handleTrustMeChange = (checked) => {
    this.setState({ trustme: checked });
    this.props.handleTrustMeChange(checked);
  };

  handleScreenNavigation = (screen) => {
    this.props.changeScreenType(screen);
  };

  handleEnterKey = (e) => {
    if (e.which === 13 || e.charCode === 13 || e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      if (this.props.step === 1) {
        this.handleEmailSubmit();
      } else {
        this.login();
      }
    }
  };

  handleEmailSubmit = () => {
    const { username } = this.state;
    if (this.props.onEmailSubmit && !isEmpty(username?.trim())) {
      this.props.onEmailSubmit(username);
    }
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    // If username prop changes (step 2), update state
    if (nextProps.username && nextProps.username !== prevState.username) {
      return { username: nextProps.username };
    }
    return null;
  }

  render() {
    const {
      username,
      password,
      remeberme,
      trustme,
      showPassword,
      idpFlow
    } = this.state;
    const {
      fetching,
      serverError,
      submitActionLoading,
      showTrustMe,
      step = 2, // default to old behavior
      supportRoute,
      showForgotPasswordLink = true
    } = this.props;

    if (fetching) {
      return (
        <div>
          <FormattedMessage id="reports.report.filter.client.loading" />
        </div>
      );
    }

    // Step 1: Only email field
    if (step === 1) {
      return (
        <LoginFormParent>
          <div className="mb20">
            <DisplayText element="h2" weight="SemiBold">
              <FormattedMessage id="common.login.email" />
            </DisplayText>
          </div>
          <Form>
            <div>
              {serverError && (
                <>
                  {serverError}
                  <br />
                </>
              )}
              <div className="mb20">
                <span onKeyPress={this.handleEnterKey}>
                  <TextField
                    value={username}
                    id="email"
                    onChange={this.handleChange('username')}
                    label={
                      <FormattedMessage id="product.userLogin.email.label" />
                    }
                    type="text"
                    name="username"
                    variant={idpFlow ? undefined : 'outline'}
                    autoFocus
                  />
                </span>
              </div>
              <div className="flex footer-block">
                <div className="flex f11">
                  <Button
                    primary
                    onClick={this.handleEmailSubmit}
                    id="emailNextBtn"
                    loading={submitActionLoading}
                  >
                    <FormattedMessage id="common.next" defaultMessage="Next" />
                  </Button>
                </div>
                {showForgotPasswordLink && (
                  <div className="flex jend actr">
                    <Link
                      url={
                        isEmpty(username)
                          ? `${envConfig.base}/#/forgotpassword`
                          : `${
                              envConfig.base
                            }/#/forgotpassword?email=${encodeURIComponent(
                              username
                            )}`
                      }
                      removeUnderline
                    >
                      <FormattedMessage id="product.userLogin.forgotPassword.label" />
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </Form>
        </LoginFormParent>
      );
    }

    // Step 2: Show password/other fields
    return (
      <LoginFormParent>
        <div className="mb20">
          <DisplayText element="h2" weight="SemiBold">
            <FormattedMessage id="common.login.email" />
          </DisplayText>
        </div>
        <Form>
          <div>
            {serverError && (
              <>
                {serverError}
                <br />
              </>
            )}
            <div className="mb20">
              <TextField
                value={username}
                id="email"
                onChange={this.handleChange('username')}
                label={<FormattedMessage id="product.userLogin.email.label" />}
                type="text"
                name="username"
                variant={idpFlow ? undefined : 'outline'}
                autoFocus
                disabled={!supportRoute}
              />
            </div>
            <div className="flex col g20">
              <span onKeyPress={this.handleEnterKey}>
                <TextField
                  value={password}
                  id="password"
                  onChange={this.handleChange('password')}
                  label={
                    <FormattedMessage id="product.userLogin.password.label" />
                  }
                  type={showPassword ? 'text' : 'password'}
                  variant={idpFlow ? undefined : 'outline'}
                  name="password"
                />
              </span>
              <Checkbox
                label={
                  <TextStyle weight="Medium">
                    <FormattedMessage id="product.userLogin.showPassword.label" />
                  </TextStyle>
                }
                checked={showPassword}
                onChange={() =>
                  this.setState((state) => ({
                    showPassword: !state.showPassword
                  }))
                }
              />
            </div>

            <div className="fx actr">
              <div className="grow-2">
                <input
                  type="hidden"
                  value={remeberme}
                  label="Remeber me"
                  checked={remeberme}
                  name="remember-me"
                  onChange={this.handleChange('remeberme')}
                />
              </div>
            </div>

            {showTrustMe && (
              <div className="fx actr mt10">
                <Checkbox
                  label={
                    <TextStyle weight="Medium">
                      <FormattedMessage id="product.userLogin.trustDeviceThirtyDays.label" />
                    </TextStyle>
                  }
                  checked={trustme}
                  onChange={this.handleTrustMeChange}
                />
              </div>
            )}

            <div>
              <div className="flex-row full-width flex-align-center footer-block">
                <div className="flex-item-balloon">
                  <Button
                    primary
                    onClick={this.login}
                    id="loginBtn"
                    loading={submitActionLoading}
                  >
                    <FormattedMessage id="common.login" />
                  </Button>
                </div>

                <div className="flex-item-fixed">
                  <Link
                    url={
                      isEmpty(username)
                        ? `${envConfig.base}/#/forgotpassword`
                        : `${
                            envConfig.base
                          }/#/forgotpassword?email=${encodeURIComponent(
                            username
                          )}`
                    }
                    removeUnderline
                  >
                    <FormattedMessage id="product.userLogin.forgotPassword.label" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </LoginFormParent>
    );
  }
}

export default LoginForm;
